import { TabContext, TabPanel } from '@mui/lab';
import { Styled } from './index.styles';
import { ReactElement, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Icon, Tab, Tabs } from '@mui/material';

interface faqsGroupModel {
    name: string;
    icon?: ReactElement;
    data: faqsModel[];
}
interface faqsModel {
    title: string;
    content: string | ReactElement;
}
interface PropsModel {
    categoryData?: faqsGroupModel[];
    defaultCategoryIndex?: number;
    data?: faqsModel[];
    className?: string;
}
const Faqs = (props: PropsModel) => {
    const { categoryData, defaultCategoryIndex = 0, data, className = '' } = props;

    const [value, setValue] = useState(defaultCategoryIndex);
    const handleChange = (event: any, newValue: number) => {
        setValue(newValue);
    };

    const AccordionCard = (props: { data: faqsModel }) => {
        const { data } = props;
        const content = typeof data.content === 'string' ? data.content : '';

        return (
            <Accordion disableGutters={true}>
                <AccordionSummary expandIcon={<Icon>expand_more</Icon>}>{data.title}</AccordionSummary>
                <AccordionDetails>
                    {' '}
                    <div dangerouslySetInnerHTML={{ __html: content }} />
                </AccordionDetails>
            </Accordion>
        );
    };

    return (
        <Styled>
            <div className={`custom-faqs ${className}`}>
                {categoryData ? (
                    <TabContext value={String(value)}>
                        <Tabs
                            value={String(value)}
                            className="tab-list"
                            variant="scrollable"
                            scrollButtons
                            allowScrollButtonsMobile
                            onChange={handleChange}
                            sx={{
                                fontWeight: 600,
                                textDecoration: 'none',
                            }}
                            TabIndicatorProps={{
                                style: { display: 'none' },
                            }}
                        >
                            {categoryData.map((item: faqsGroupModel, index: number) => {
                                return (
                                    <Tab
                                        className={`${index == value && 'selected'}`}
                                        key={index}
                                        icon={item.icon}
                                        iconPosition={item.icon && 'start'}
                                        label={item.name}
                                        value={String(index)}
                                    />
                                );
                            })}
                        </Tabs>
                        <TabPanel value={String(categoryData.indexOf(categoryData[value]))}>
                            {categoryData[value].data.map((items: faqsModel, indexs: number) => {
                                return <AccordionCard key={indexs} data={items} />;
                            })}
                        </TabPanel>
                    </TabContext>
                ) : (
                    <>
                        {data?.map((items: faqsModel, indexs: number) => {
                            return <AccordionCard key={indexs} data={items} />;
                        })}
                    </>
                )}
            </div>
        </Styled>
    );
};

export default Faqs;
